import { format } from 'date-fns';
import * as z from 'zod';
import { base64toBlob } from '../../MyQualification/helper';
import employeeService from '../../../services/EmployeeService';

export const getPhoneString = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'object') {
    return value.FreeFormNumber || '';
  }
  return '';
};

export const normalizePhoneNumber = (phone = '') => phone.trim().replace(/[\s()-]/g, '');

/* 
format employeeList of Verd database
**/
export function getFormattedEmployeeList(employeeList) {
  return employeeList.map((item) => ({
    id: item._id,
    email: item.email,
    workEmail: item.workEmail,
    Phone: getPhoneString(item.PrimaryPhone) || getPhoneString(item.Mobile) || '',
    userRole: item.type,
    DisplayName: item.FirstName && item.FamilyName ? item.FirstName + ' ' + item.FamilyName : item.DisplayName,

    FirstName: item.FirstName || '',
    FamilyName: item.FamilyName || '',
    MiddleName: item.MiddleName || '',
    Title: item.Title || item.title || '',
    PrimaryPhone: getPhoneString(item.PrimaryPhone) || getPhoneString(item.Mobile) || '',

    Country: item.PrimaryAddr?.Country || '',
    CountrySubDivisionCode: item.PrimaryAddr?.CountrySubDivisionCode || '',
    PostalCode: item.PrimaryAddr?.PostalCode || '',
    Line1: item.PrimaryAddr?.Line1 || '',
    City: item.PrimaryAddr.City || '',

    DateOfBirth: item.DateOfBirth ? format(new Date(item.DateOfBirth), 'yyyy-MM-dd') : '',
    AnniversaryDate: item.AnniversaryDate ? format(new Date(item.AnniversaryDate), 'yyyy-MM-dd') : '',

    KeyPayEmployeeId: item.KeyPayEmployeeId || '',
    HiredDate: item.HiredDate ? format(new Date(item.HiredDate), 'yyyy-MM-dd') : new Date(),
    ReleasedDate: item.ReleasedDate ? format(new Date(item.ReleasedDate), 'yyyy-MM-dd') : new Date(),
    selectedEmployeeId: undefined,
    jobTitle: item.jobTitle || '',
    employeeType: item.type || 'User',
    portalAccess: item.portalAccess ? item.portalAccess : false,

    //accounting
    vendorRef: item.vendorRef,
    itemRef: item.itemRef,
    taxType: item.taxType,
    hourRate: item.hourRate || '',

    //mandatory quals from verd db
    mandatoryQualifications: item.mandatoryQualifications || []
  }));
}

/* 
format keyPay employee according to Verd database and input fields in user dialog
**/
export function getFormattedEmployeeFromSelectedObj(selectedObj) {
  let keyPayUserDateOfBirth, keyPayUserAnniversaryDate;

  if (selectedObj.dateOfBirth) {
    keyPayUserDateOfBirth = format(new Date(selectedObj.dateOfBirth), 'yyyy-MM-dd');
  }

  if (selectedObj.anniversaryDate) {
    keyPayUserAnniversaryDate = format(new Date(selectedObj.anniversaryDate), 'yyyy-MM-dd');
  }

  return {
    FirstName: selectedObj.GivenName || selectedObj.firstName || selectedObj.FullyQualifiedName || '',
    FamilyName: selectedObj.FamilyName || selectedObj.surname || '',
    MiddleName: selectedObj.MiddleName || selectedObj.middleName || '',
    Title: selectedObj.Title || selectedObj.title || '',
    PrimaryPhone:
      getPhoneString(selectedObj.PrimaryPhone) ||
      getPhoneString(selectedObj.mobilePhone) ||
      getPhoneString(selectedObj.Mobile) ||
      '',

    Country: selectedObj.BillAddr?.Country || selectedObj.residentialCountry || '',
    CountrySubDivisionCode: selectedObj.BillAddr?.CountrySubDivisionCode || selectedObj.residentialState || '',
    PostalCode: selectedObj.BillAddr?.PostalCode || selectedObj.residentialPostCode || '',
    Line1: selectedObj.BillAddr?.Line1 || selectedObj.residentialStreetAddress || '',
    City: selectedObj.BillAddr?.City || selectedObj.postalSuburb || '',

    email: selectedObj.PrimaryEmailAddr?.Address || selectedObj.emailAddress || '',
    DateOfBirth: selectedObj.DateOfBirth || keyPayUserDateOfBirth || null,
    AnniversaryDate: selectedObj.AnniversaryDate || keyPayUserAnniversaryDate || null,

    bankAccount1_AccountName: selectedObj.bankAccount1_AccountName || '',
    bankAccount1_BSB: selectedObj.bankAccount1_BSB || '',
    bankAccount1_AccountNumber: selectedObj.bankAccount1_AccountNumber || '',

    superFund1_ProductCode: selectedObj.superFund1_ProductCode || '',
    superFund1_MemberNumber: selectedObj.superFund1_MemberNumber || '',
    superFund1_FundName: selectedObj.superFund1_FundName || '',

    emergencyContact1_Address: selectedObj.emergencyContact1_Address || '',
    emergencyContact1_ContactNumber: selectedObj.emergencyContact1_ContactNumber || '',
    emergencyContact1_Name: selectedObj.emergencyContact1_Name || '',
    emergencyContact1_Relationship: selectedObj.emergencyContact1_Relationship || '',

    bankAccount1_AllocatedPercentage: selectedObj.bankAccount1_AllocatedPercentage,
    superFund1_AllocatedPercentage: selectedObj.superFund1_AllocatedPercentage,

    KeyPayEmployeeId: selectedObj.id || '',
    HiredDate: selectedObj.startDate || new Date(),
    ReleasedDate: selectedObj.endDate || new Date(),
    selectedEmployeeId: undefined,
    jobTitle: selectedObj.jobTitle || '',
    keyPayEmployeeHourlyRate: selectedObj.rate || ''
  };
}

/*
format selectedEmployee, chosen from keyPay/supplier and if edited use those edited inputs data
**/
export function getFormattedEmployeePayload(selectedEmployee, editedRow) {
  return {
    // eslint-disable-next-line no-undef
    token: localStorage.getItem('token'),
    updateUserId: editedRow.id,
    FirstName: editedRow.FirstName ?? selectedEmployee?.FirstName ?? '',
    FamilyName: editedRow.FamilyName ?? selectedEmployee?.FamilyName ?? '',
    MiddleName: editedRow?.MiddleName ?? selectedEmployee?.MiddleName ?? '',
    Title: editedRow?.Title ?? selectedEmployee?.Title ?? '',
    PrimaryPhone: editedRow?.PrimaryPhone ?? editedRow?.Phone ?? selectedEmployee?.PrimaryPhone ?? '',

    Country: editedRow?.Country || selectedEmployee?.Country || '',
    CountrySubDivisionCode: editedRow?.CountrySubDivisionCode || selectedEmployee?.CountrySubDivisionCode || '',
    PostalCode: editedRow?.PostalCode || selectedEmployee?.PostalCode || '',
    Line1: editedRow?.Line1 || selectedEmployee?.Line1 || '',
    City: editedRow?.City || selectedEmployee?.City || '',

    email: editedRow?.email ?? selectedEmployee?.email ?? '',
    workEmail: editedRow?.workEmail ?? selectedEmployee?.workEmail ?? '',

    DateOfBirth: editedRow?.DateOfBirth || selectedEmployee?.DateOfBirth || null,
    AnniversaryDate: editedRow?.AnniversaryDate || selectedEmployee?.AnniversaryDate || null,

    KeyPayEmployeeId: editedRow?.KeyPayEmployeeId ?? selectedEmployee?.KeyPayEmployeeId ?? '',
    HiredDate: selectedEmployee?.startDate || new Date(),
    ReleasedDate: selectedEmployee?.endDate || new Date(),
    selectedEmployeeId: editedRow.id || selectedEmployee?.id || '',
    jobTitle: editedRow?.jobTitle ?? selectedEmployee?.jobTitle ?? ''
  };
}

export const userFormSchema = z
  .object({
    FirstName: z.string().trim().min(1, 'First name is required.'),
    FamilyName: z.string().trim().min(1, 'Last name is required.'),
    email: z.string().trim().min(1, 'Email is required.').email('Enter a valid email address.'),
    workEmail: z.union([z.literal(''), z.string().trim().email('Enter a valid work email address.')]),
    PrimaryPhone: z
      .string()
      .trim()
      .min(1, 'Phone is required.')
      .transform(normalizePhoneNumber)
      .refine((phone) => /^04\d{8}$/.test(phone), 'Use a 10-digit Australian mobile beginning with 04.'),
    userRole: z.string().trim().min(1, 'User role is required.')
  })
  .passthrough()
  .superRefine((values, context) => {
    if (values.approvalRequired && !values.approverId) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['approverId'],
        message: 'Select an approver.'
      });
    }
  });

export const getDirtyFormValues = (values, dirtyFields) =>
  Object.keys(dirtyFields || {}).reduce((changes, field) => {
    if (dirtyFields[field]) changes[field] = values[field];
    return changes;
  }, {});

/* 
if existing row/user's employee type is changed then use changed type before updating
**/
export function updateEmployeeType(selectedEmployeeType, editedRow) {
  return (editedRow = { ...editedRow, type: selectedEmployeeType.value });
}

/* 
if approval required and approverId is changed update editedRow
**/
export function updateEmployeeApprovalDetails(selectedApprover, approvalRequired, editedRow) {
  return (editedRow = { ...editedRow, approverId: selectedApprover?.id, approvalRequired: approvalRequired });
}

export function isLinkEmployeeValid(linkEmployeePayload) {
  if (
    linkEmployeePayload.employeeId &&
    linkEmployeePayload.itemRef &&
    linkEmployeePayload.vendorRef &&
    linkEmployeePayload.taxType &&
    linkEmployeePayload.hourRate
  )
    return true;
  return false;
}

export function isSupplierBillValid(supplierChecked) {
  if (supplierChecked) return true;
  return false;
}

export function isSuperAnnuationValid(superChecked, superPercentage, superAccount, superPayableAccount) {
  if (superChecked) {
    if (
      superPercentage &&
      superAccount?.value &&
      superAccount?.id &&
      superPayableAccount?.value &&
      superPayableAccount?.id
    )
      return true;
  }

  if (!superChecked)
    if (
      !superPercentage &&
      !superAccount?.value &&
      !superAccount?.id &&
      !superPayableAccount?.value &&
      !superPayableAccount?.id
    ) {
      return true;
    }

  return false;
}

export function formatUserUniform(row, employeeUniform) {
  const uniformRecord = {
    shirtSize: employeeUniform.shirtSize,
    jacketSize: employeeUniform.jacketSize,
    jumperSize: employeeUniform.jumperSize,
    employeeId: row.id
  };
  return uniformRecord;
}

export const employeeUniformSchema = z.object({
  shirtSize: z.string().min(1, { message: 'Shirt size is required' }),
  jumperSize: z.string().min(1, { message: 'Jumper size is required' }),
  jacketSize: z.string().min(1, { message: 'Jacket size is required' }),
  employeeId: z.string().or(z.literal(''))
});

export function formatEmployeeQualifications(records) {
  return records.map((data) => {
    const qualification = data;
    let fileContent = '';

    if (qualification.qualificationUrl) {
      fileContent = qualification.qualificationUrl;
    } else if (qualification.content?.bytes) {
      const photoOfCard = base64toBlob(
        qualification.content?.bytes,
        qualification.content?.contentType,
        qualification.content?.filename
      );
      // eslint-disable-next-line no-undef
      fileContent = URL.createObjectURL(photoOfCard);
    }

    const employeeQualification = {
      expiryDate: qualification?.expiryDate ? format(new Date(qualification.expiryDate), 'yyyy-MM-dd') : '',
      issueDate: qualification?.issueDate ? format(new Date(qualification.issueDate), 'yyyy-MM-dd') : '',
      fileContent: fileContent,
      cardNumber: qualification?.referenceNumber || '',
      qualificationId: qualification?.qualificationId,
      documentId: qualification?.documents?.[0]?.id || qualification?.documentId,
      status: qualification?.status || ''
    };

    return employeeQualification;
  });
}

export const employeeEmailSchema = z.object({
  existingEmail: z.string().email(),
  latestEmail: z
    .string()
    .email()
    .refine(async (e) => {
      const employees = await employeeService.getEmployees();
      const emails = employees.data?.data?.map((employee) => employee.email);
      return !emails.includes(e);
    }, 'This email already exist in database. Email address must be unique to change.'),
  employeeKeyPayId: z.string(),
  employeeId: z.string()
});

//if any of this column's value is clicked, then can be inline editing
export const INLINE_COLUMNS = ['userRole', 'Phone', 'vendorRef', 'itemRef', 'taxType', 'jobTitle', 'hourRate'];

export const requiredRule = {
  isValid: (value) => (value?.trim()?.length ?? 0) > 0,
  errorText: 'This field is required'
};

export const validationRules = {
  Phone: {
    // Australian mobiles are 10 digits: 04 + 8 digits (e.g. 0412 345 678)
    isValid: (Phone) => !!Phone && /^04\d{8}$/.test(normalizePhoneNumber(Phone)),
    errorText: 'Phone must be a 10-digit Australian mobile starting with 04 (e.g. 0412345678).'
  },
  email: {
    isValid: (email) => !!email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email),
    errorText: 'Please enter a valid email address (e.g. name@example.com).'
  },
  workEmail: {
    isValid: (workEmail) => !workEmail || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(workEmail),
    errorText: 'Please enter a valid work email address (e.g. name@company.com).'
  },
  userRole: requiredRule
};

export const validateChanges = (changed) =>
  Object.keys(changed).reduce(
    (status, rowId) => {
      const rowChanges = changed[rowId] || {};
      // Start fresh — only validate fields present in the current change.
      // Do NOT carry over old validation results for other fields; stale
      // errors from a previous failed save would otherwise block a valid save.
      const rowStatus = {};

      Object.keys(rowChanges).forEach((field) => {
        const rule = validationRules[field];
        if (!rule) return; // no rule -> don't block this field
        const isValid = !!rule.isValid(rowChanges[field]);
        rowStatus[field] = { isValid, error: isValid ? null : rule.errorText };
      });

      return { ...status, [rowId]: rowStatus };
    },
    {} // start from an empty slate, not the old status
  );

export const hasValidationErrors = (changed, validationStatus) =>
  Object.keys(changed).some((rowId) =>
    Object.keys(changed[rowId] || {}).some((field) => validationStatus[rowId]?.[field]?.isValid === false)
  );

export const isLinkEmployeeChange = (changeObject) => {
  const objectKeys = Object.keys(changeObject);
  return ['vendorRef', 'itemRef', 'taxType', 'hourRate'].some((field) => objectKeys.includes(field));
};

export function extractCardDetails(controllerUser) {
  if (!controllerUser) return [];

  return Object.keys(controllerUser)
    .map((key) => key.match(/^CardFac(\d+)$/)?.[1])
    .filter((index) => Boolean(index))
    .map(Number)
    .filter((index) => {
      const facilityCode = controllerUser[`CardFac${index}`];
      const cardNumber = controllerUser[`CardNum${index}`];
      return Boolean(facilityCode && cardNumber);
    })
    .sort((left, right) => left - right)
    .map((index) => ({
      index,
      facilityCode: controllerUser[`CardFac${index}`],
      cardNumber: controllerUser[`CardNum${index}`]
    }));
}
